// THE ABOVE CODE IS PREVIOS VERSION OF THIS CODE, THE CODE BELOW IS OLDER THAN THAT

import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import favoritesEvents from "../../../Utils/favoritesEvents";
import axios from "axios";
import Swal from "sweetalert2"; // Import SweetAlert2

import arrowdown from "../../../Assets/Images/Landing/arrowdown.png";
import arrowright from "../../../Assets/Images/Landing/arrowright.png";
import star from "../../../Assets/Images/Landing/star.png";
import blankstar from "../../../Assets/Images/Landing/blankstar.png";
import { FULL_API_BASE_URL } from "../../../Config/Config";

import { useSelector } from "react-redux";
import Colors from "../../../Constants/Colors";
import "../MenuTreeStructure.css";
import arrowRightLevel2 from "../../../Assets/Images/CommanImages/Rectangle 36.png";
const Item = ({
  selectedLvl1,
  setSelectedLvl1,
  item,
  level = 0,
  setPagePath,
  hierarchy = "",
}) => {
  const [isOpened, setIsOpened] = useState(false);
  const [favStatus, setFavStatus] = useState(item.my_fav);

  const { data } = useSelector((state) => state.landing);
  const userId = data && data.client_schema_name[6][0].user_id;
  const clientBrId = data && data.client_schema_name[6][0].client_branch_id;

  useEffect(() => {
    const unsubscribeRemove = favoritesEvents.on(
      "favoriteRemoved",
      (screenId) => {
        if (item.screen_id === screenId) {
          setFavStatus(0);
        }
      }
    );

    const unsubscribeAdd = favoritesEvents.on("favoriteAdded", (screenId) => {
      if (item.screen_id === screenId) {
        setFavStatus(1);
      }
    });

    // Cleanup on unmount
    return () => {
      unsubscribeRemove();
      unsubscribeAdd();
    };
  }, [item.screen_id]);

  // const toggleFavorite = async (screen_id) => {
  //   try {
  //     if (favStatus === 1) {
  //       await axios.post(
  //         `${FULL_API_BASE_URL}/manage-user-favourite?operation=delete&user_id=${userId}&screen_id=${item.screen_id}&client_br_id=${clientBrId}`
  //       );
  //       setFavStatus(0);
  //     } else {
  //       await axios.post(
  //         `${FULL_API_BASE_URL}/manage-user-favourite?operation=create&user_id=${userId}&screen_id=${item.screen_id}&client_br_id=${clientBrId}`
  //       );
  //       setFavStatus(1);
  //     }

  //   } catch (error) {
  //     console.error("Error updating favorite status", error);
  //   }
  // };

  const toggleFavorite = async (screen_id) => {
    try {
      if (favStatus === 1) {
        await axios.post(
          `${FULL_API_BASE_URL}/manage-user-favourite?operation=delete&user_id=${userId}&screen_id=${item.screen_id}&client_br_id=${clientBrId}`
        );
        setFavStatus(0);
        // Emit event to sync with My Favorites dropdown
        favoritesEvents.removeFavorite(item.screen_id);
      } else {
        await axios.post(
          `${FULL_API_BASE_URL}/manage-user-favourite?operation=create&user_id=${userId}&screen_id=${item.screen_id}&client_br_id=${clientBrId}`
        );
        setFavStatus(1);
        // Emit event to sync with My Favorites dropdown
        favoritesEvents.addFavorite(item.screen_id);
      }
    } catch (error) {
      console.error("Error updating favorite status", error);
    }
  };

  const currentHierarchy = hierarchy
    ? `${hierarchy} > ${item.name}`
    : item.name;

  const handleClick = () => {
    setIsOpened(!isOpened);
    if (!item.children && item.ui_path) {
      setPagePath(currentHierarchy);
    }
  };

  const handleLevel1Click = (e) => {
    e.stopPropagation();
    // Single click: select this Level 1
    if (level === 0) setSelectedLvl1(item.name);
    handleClick();
  };

  const handleLevel1DoubleClick = (e) => {
    e.stopPropagation();
    // Double click: deselect Level 1
    if (level === 0) setSelectedLvl1(null);
    // Optionally: also collapse, etc.
  };
  // Style for Level 1 with margin for image
  const lvl1ImageStyle =
    level === 0
      ? { marginLeft: "12px", marginRight: "10px", width: "20px" }
      : { width: "20px" };

  const renderLeaf = () => {
    if (item.ui_path) {
      return (
        <Link
          to={item.ui_path}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "71%",
            color: `${item.colors}`,
          }}
        >
          {/* {item.name} */}
          <span className="trunc-text" title={item.name}>
            {item.name}
          </span>

          <img
            src={favStatus === 1 ? star : blankstar}
            style={{ width: "13px" }}
            onClick={(e) => {
              e.preventDefault();
              toggleFavorite(item.screen_id);
            }}
          />
        </Link>
      );
    } else {
      return (
        <>
          {/* {item.name} */}
          <span className="trunc-text" title={item.name}>
            {item.name}
          </span>

          <img
            src={favStatus === 1 ? star : blankstar}
            style={{ width: "12px", marginTop: "-10px" }}
            onClick={(e) => {
              e.preventDefault();
              toggleFavorite(item.screen_id);
            }}
          />
        </>
      );
    }
  };

  const renderSecondLevel = () => {
    if (item.children.length === 0 && item.ui_path) {
      return (
        <Link
          to={item.ui_path}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "80%",
            color: `${item.colors}`,
            marginLeft: "12px",
          }}
          onClick={() => setPagePath(currentHierarchy)}
        >
          {item.name}
          <img
            src={favStatus === 1 ? star : blankstar}
            style={{ width: "13px" }}
            onClick={(e) => {
              e.preventDefault();
              toggleFavorite(item.screen_id);
            }}
          />
        </Link>
      );
    } else {
      return item.name;
    }
  };

  const isLevel1Selected = level === 0 && selectedLvl1 === item.name;

  const itemStyle = {
    color: isLevel1Selected ? `${Colors.color14}` : `${Colors.color9}`,
    fontSize: level === 0 ? "16px" : "14.5px",
    display: "flex",
    alignItems: "center",
    width: "100%",
    cursor: "pointer",
    fontWeight: level === 0 ? "600" : "normal",
    marginBottom: level === 0 ? "10px" : "5px",
    // marginLeft: !item.children ? "10px" : "",
    marginLeft:
      level === 1 ? "4px" : level > 1 ? `${28 + (level - 1) * 12}px` : "0px",
  };

  return (
    <div style={{ marginLeft: level === 0 ? "0px" : "0px" }}>
      <div
        className="menu-item"
        style={{
          ...itemStyle,
        }}
        onClick={level === 0 ? handleLevel1Click : handleClick}
        onDoubleClick={level === 0 ? handleLevel1DoubleClick : undefined}
      >
        {item.children && item.children.length > 0 ? (
          level === 1 ? (
            <img
              src={arrowRightLevel2}
              className={isOpened ? "rotate-90" : ""}
              style={{
                width: "9px",
                marginRight: "4px",
                marginLeft: "13px",
              }}
              alt=""
            />
          ) : isOpened ? (
            <img
              src={arrowdown}
              style={{
                width: "9px",
                marginRight: "4px",
                marginLeft: "0px",
              }}
              alt=""
            />
          ) : (
            <img
              src={arrowright}
              style={{
                width: "9px",
                marginRight: "4px",
                marginLeft: "0px",
              }}
              alt=""
            />
          )
        ) : null}

        {!item.children ? renderLeaf() : renderSecondLevel()}
      </div>

      {item.children && (
        <div className={`sub-menu ${isOpened ? "" : "sub-menu--shrunk"}`}>
          {item.children.map((subitem) => (
            <Item
              key={subitem.name}
              item={subitem}
              level={level + 1}
              setPagePath={setPagePath}
              hierarchy={currentHierarchy}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default Item;
